exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comments[data-v-6c8ff403] {\n  margin-bottom: 10px;\n}\n.comment[data-v-6c8ff403] {\n  margin: 30px 0;\n  font-size: 16px;\n  line-height: 20px;\n  color: var(--color-neutral-90);\n  font-weight: bold;\n}\n.comment .comment__text[data-v-6c8ff403] {\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 400;\n  color: inherit;\n}\n", ""]);

// exports
